/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    FormControlLabel,
    Typography,
    Checkbox,
    Divider,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/system';
import { Add, Delete } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { validateAlphaPlus } from 'utils/commonHelpers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const EditViewDialog = ({ onClose, onCloseCancel, data, viewData, selectedViewStatements, ruleStatementValues, inputFields }) => {
    const theme = useTheme();
    const [viewname, setViewName] = useState(viewData.name);
    const [viewDescription, setViewDescription] = useState(viewData.description);
    const [enabled, setEnabled] = useState(viewData.enabled);
    const [disableAddClause, setDisableAddClause] = useState(true);
    const [ruleStatements, setRuleStatements] = useState([]);
    const operatorLookupsData = data.view.operator_lookups;
    const [groupAttributeId, setGroupAttributeId] = useState();
    const [deviceTypeAttributeId, setDeviceTypeAttributeId] = useState();
    const [lastupdatedAttributeId, setLastupdatedAttributeId] = useState();
    console.log(ruleStatementValues);

    useEffect(() => {
        const initialStatements = selectedViewStatements.map((statement, index) => {
            const attribute = data.view.attributes.find((attribute) => attribute.attribname === statement.deviceattrib);
            const operatorLookup = operatorLookupsData.some((item) => item.attrib.attribname === statement.deviceattrib);
            let valueOptions = [];
            let valueTextField = true;
            let operatorOptions = data.operators;
            if (operatorLookup) {
                operatorOptions = operatorLookupsData
                    .filter((item) => item.attrib.attribid === attribute.attribid)
                    .map((item) => item.theoper);
                if (statement.deviceattrib === 'groupid') valueOptions = ruleStatementValues.group_values;
                else if (statement.deviceattrib === 'devtype') valueOptions = ruleStatementValues.device_type_values;
                else valueOptions = [{ name: 'Yes' }, { name: 'No' }];
                valueTextField = false;
            }

            let value = statement.value;
            if (statement.deviceattrib === 'isportable' || statement.deviceattrib === 'islicensed') {
                value = statement.value == 1 ? 'Yes' : 'No';
            }

            return {
                id: index + 1,
                attribute: attribute?.attribid || '',
                negative: statement.negative === 1 ? true : false,
                operator: statement.operator_id,
                value: value,
                connector: index === selectedViewStatements.length - 1 ? '1' : statement.connector_id,
                disabledConnector: index === selectedViewStatements.length - 1 ? true : false, // last item should be disabled
                operatorOptions: operatorOptions,
                valueTextField: valueTextField,
                valueOptions: valueOptions
            };
        });
        setRuleStatements(initialStatements);
    }, []);

    useEffect(() => {
        operatorLookupsData.map((operatorLookupData) => {
            if (operatorLookupData.attrib.attribname === 'groupid') {
                setGroupAttributeId(operatorLookupData.attrib.attribid);
            }
            if (operatorLookupData.attrib.attribname === 'devtype') {
                setDeviceTypeAttributeId(operatorLookupData.attrib.attribid);
            }
            if (operatorLookupData.attrib.attribname === 'lastconnect') {
                setLastupdatedAttributeId(operatorLookupData.attrib.attribid);
            }
        });
    }, [operatorLookupsData]);

    useEffect(() => {
        ruleStatements.map((ruleStatementData) => {
            if (ruleStatementData['attribute'] !== '' && ruleStatementData['operator'] !== '' && ruleStatementData['value'] !== '') {
                setDisableAddClause(false);
            } else {
                setDisableAddClause(true);
            }
        });
    }, [ruleStatements]);

    const handleChangeName = (e) => {
        if (e.target.value.length > inputFields['name']) {
            toast.warning('This field must be ' + inputFields['name'] + ' characters or less.');
        } else {
            setViewName(e.target.value);
        }
    };

    const handleChangeDesc = (e) => {
        if (e.target.value.length > inputFields['desc']) {
            toast.warning('This field must be ' + inputFields['desc'] + ' characters or less.');
        } else {
            setViewDescription(e.target.value);
        }
    };

    const handleAddClause = () => {
        const tmp = JSON.parse(JSON.stringify(ruleStatements));
        for (let i = 0; i < tmp.length; i++) {
            tmp[i]['disabledConnector'] = false;
        }
        tmp.push({
            id: ruleStatements.length + 1,
            attribute: '',
            negative: false,
            operator: '',
            value: '',
            connector: '1',
            disabledConnector: true,
            operatorOptions: data.operators,
            valueTextField: true,
            valueOptions: []
        });
        setRuleStatements(tmp);
    };

    const handleDeleteRuleStatement = (key) => {
        const tmp = JSON.parse(JSON.stringify(ruleStatements));
        const index = tmp.findIndex((rule) => rule.id === key);
        tmp.splice(index, 1);
        tmp[tmp.length - 1]['disabledConnector'] = true;
        setRuleStatements(tmp);
    };

    const handleChangeInputRuleStatementData = (e, ruleId) => {
        const tmp = JSON.parse(JSON.stringify(ruleStatements));
        const selectedRule = tmp.filter((rule) => rule.id === ruleId);

        if (e.target.name === 'negative') {
            selectedRule[0][e.target.name] = e.target.checked;
        } else {
            selectedRule[0][e.target.name] = e.target.value;
            const operatorLookup = operatorLookupsData.some((item) => item.attrib.attribid === selectedRule[0]['attribute']);
            if (operatorLookup) {
                selectedRule[0]['operatorOptions'] = operatorLookupsData
                    .filter((item) => item.attrib.attribid === selectedRule[0]['attribute'])
                    .map((item) => item.theoper);
                if (selectedRule[0]['attribute'] === groupAttributeId) selectedRule[0]['valueOptions'] = ruleStatementValues.group_values;
                else if (selectedRule[0]['attribute'] === deviceTypeAttributeId)
                    selectedRule[0]['valueOptions'] = ruleStatementValues.device_type_values;
                else selectedRule[0]['valueOptions'] = [{ name: 'Yes' }, { name: 'No' }];
                selectedRule[0]['valueTextField'] = false;
            } else {
                selectedRule[0]['valueTextField'] = true;
                selectedRule[0]['operatorOptions'] = data.operators;
            }
        }
        setRuleStatements(tmp);
    };

    const handleSubmit = () => {
        if (viewname === '') {
            toast.info('The view name is required');
            return true;
        }
        if (!validateAlphaPlus(viewname)) {
            toast.info('The view name must be alphanumeric');
            return true;
        }
        if (!validateAlphaPlus(viewDescription)) {
            toast.info('The view description must be alphanumeric');
            return true;
        }
        ApiHelper.put(`/api/management/views/${viewData.id}/`, {
            view_name: viewname,
            view_description: viewDescription,
            enabled: enabled,
            rule_statements: ruleStatements
        })
            .then(() => {
                toast.success('Successfully added.');
                onClose();
            })
            .catch((err) => {
                toast.error(`Failed! ${err.response.data.message}`);
            });
    };

    return (
        <Dialog open={true} onClose={onCloseCancel}>
            <DialogTitle sx={{ fontSize: '16px' }}>Edit View</DialogTitle>
            <DialogContent sx={{ minWidth: '900px' }}>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TextField sx={{ width: '100%' }} label="View Name" value={viewname} onChange={(e) => handleChangeName(e)} />
                        </Grid>
                        <Grid item xs={3} sx={{ mt: 1 }}>
                            <FormControlLabel
                                value="end"
                                sx={{ float: 'right' }}
                                control={<Checkbox checked={!!enabled} onChange={(e) => setEnabled(e.target.checked)} />}
                                label="Use This View"
                                labelPlacement="end"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="View Description"
                                value={viewDescription}
                                inputProps={{
                                    maxLength: inputFields['desc']
                                }}
                                onChange={(e) => handleChangeDesc(e)}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Divider sx={{ border: `1px solid ${theme.palette.primary.main}` }} />
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Grid container spacing={1}>
                        {ruleStatements.map((ruleStatementData, ruleStatementKey) => (
                            <React.Fragment key={ruleStatementKey}>
                                <Grid item xs={1}>
                                    {ruleStatementData.id === 1 ? (
                                        <Typography sx={{ padding: 2, fontSize: '16px' }}>IF</Typography>
                                    ) : (
                                        <IconButton
                                            size="medium"
                                            sx={{
                                                float: 'right'
                                            }}
                                            color="error"
                                            onClick={() => handleDeleteRuleStatement(ruleStatementData.id)}
                                        >
                                            <Delete fontSize="medium" />
                                        </IconButton>
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel>Attribute</InputLabel>
                                        <Select
                                            label="Attribute"
                                            name="attribute"
                                            value={ruleStatementData['attribute']}
                                            onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                        >
                                            {data?.view?.attributes.map((attributeData, key) => (
                                                <MenuItem key={key} value={attributeData.attribid}>
                                                    {attributeData.attrib_label ? attributeData.attrib_label : attributeData.attribname}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1}>
                                    <FormControlLabel
                                        value="top"
                                        control={
                                            <Checkbox
                                                name="negative"
                                                checked={ruleStatementData['negative']} // Changed from value to checked
                                                onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                            />
                                        }
                                        label="NOT"
                                        labelPlacement="top"
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel>Operator</InputLabel>
                                        <Select
                                            label="Operator"
                                            name="operator"
                                            value={ruleStatementData['operator']}
                                            onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                        >
                                            {ruleStatementData['operatorOptions'].map((operatorData, key) => (
                                                <MenuItem key={key} value={operatorData.operatorid}>
                                                    {operatorData.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    {ruleStatementData['attribute'] === lastupdatedAttributeId ? (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Select Date"
                                                dateFormat="yyyy-MM-dd"
                                                value={ruleStatementData['value']}
                                                onChange={(newDate) =>
                                                    handleChangeInputRuleStatementData(
                                                        { target: { name: 'value', value: newDate } },
                                                        ruleStatementData.id
                                                    )
                                                }
                                                renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                                            />
                                        </LocalizationProvider>
                                    ) : ruleStatementData['valueTextField'] === false ? (
                                        <FormControl sx={{ width: '100%' }}>
                                            <InputLabel>Value</InputLabel>
                                            <Select
                                                label="Value"
                                                name="value"
                                                value={ruleStatementData['value']}
                                                onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                            >
                                                {ruleStatementData['valueOptions'].map((valueOption, key) => (
                                                    <MenuItem key={key} value={valueOption.name ? valueOption.name : valueOption.devtype}>
                                                        {valueOption.name ? valueOption.name : valueOption.devtype}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <TextField
                                            sx={{ width: '100%' }}
                                            label="Value"
                                            name="value"
                                            value={ruleStatementData['value']}
                                            inputProps={{
                                                maxLength: inputFields['attr']
                                            }}
                                            onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={1}>
                                    <Select
                                        name="connector"
                                        value={ruleStatementData['connector']}
                                        disabled={ruleStatementData['disabledConnector']}
                                        onChange={(e) => handleChangeInputRuleStatementData(e, ruleStatementData.id)}
                                    >
                                        {data.connectors.map((connectorData, key) => (
                                            <MenuItem key={key} value={connectorData.connectorid}>
                                                {connectorData.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" startIcon={<Add />} onClick={handleAddClause} disabled={disableAddClause}>
                    Add Clause
                </Button>
                <Button onClick={onCloseCancel}>Cancel</Button>
                <Button onClick={handleSubmit} disabled={disableAddClause}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EditViewDialog.propTypes = {
    onClose: PropTypes.func,
    onCloseCancel: PropTypes.func,
    data: PropTypes.object,
    viewData: PropTypes.object,
    selectedViewStatements: PropTypes.array,
    ruleStatementValues: PropTypes.object,
    ruleStatementsData: PropTypes.array,
    inputFields: PropTypes.object
};

export default EditViewDialog;
